import { DialogActionData } from '@/generated/classes/Dialog'
import Dialog from '@/generated/classes/Dialog'
import HubServices from "@/generated/hub/HubServices";

export interface HubDialogAnswer {
  (obj: unknown): void;
}

export interface HubDialogNotification {
  (dialog: Dialog): void;
}

export default class DialogHubManager {
  private static mapHubDialog = new Map<string, HubDialogAnswer>;
  private static questionHandlers: HubDialogNotification[] = [];
  private static refreshHandlers: HubDialogNotification[] = [];
  private static initialised = false;

  public static initialise (): void {
    if (DialogHubManager.initialised) {
      return;
    }
    DialogHubManager.initialised = true;
    HubServices.onDialogQuestion(this.notifyQuestion);
    HubServices.onDialogAction(this.notify);
    HubServices.onDialogRefresh(this.notifyRefresh);
  }

  public static waitQuestion (fct: HubDialogNotification): () => void {
    DialogHubManager.initialise();
    DialogHubManager.questionHandlers.push(fct);
    return () => DialogHubManager.removeHandler(DialogHubManager.questionHandlers, fct);
  }

  public static waitRefresh (fct: HubDialogNotification): () => void {
    DialogHubManager.initialise();
    DialogHubManager.refreshHandlers.push(fct);
    return () => DialogHubManager.removeHandler(DialogHubManager.refreshHandlers, fct);
  }

  public static waitAnswer (method: string, fct: HubDialogAnswer): void {
    DialogHubManager.initialise();
    DialogHubManager.mapHubDialog.set(method, fct);
  }

  public static notify (data: DialogActionData): void {
    const fct = DialogHubManager.mapHubDialog.get(data.method);
    if (fct) {
      fct(data.obj);
    }
  }

  private static notifyQuestion (dialog: Dialog): void {
    const handlers = DialogHubManager.questionHandlers;
    handlers[handlers.length - 1]?.(dialog);
  }

  private static notifyRefresh (dialog: Dialog): void {
    const handlers = DialogHubManager.refreshHandlers;
    handlers[handlers.length - 1]?.(dialog);
  }

  private static removeHandler (handlers: HubDialogNotification[], fct: HubDialogNotification): void {
    const index = handlers.lastIndexOf(fct);
    if (index >= 0) {
      handlers.splice(index, 1);
    }
  }
}



